import { useCallback } from "react";
import axiosInstance from "../axiosInstance";

const useDeleteGuestList = () =>
  useCallback((id) => {
    const baseUrl = window.localStorage.getItem("BaseURL");
    const endpoint = "/services/projectmanagement/api/guest-groups/" + id;
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance
        .delete(fullUrl)
        .then((res) => resolve(res.data))
        .catch(reject);
    });
  }, []);

export default useDeleteGuestList;
